export const tryJson = (value: string): Record<string, unknown> | string => {
  try {
    return JSON.parse(value)
  } catch (e) {
    return value
  }
}
